/**
 * 检查值是否为非空数组
 *
 * @description
 * 判断一个值是否为数组，并且数组长度大于0
 *
 * @param value - 要检查的值
 * @returns {boolean} 如果值是非空数组返回true，否则返回false
 *
 * @example
 * ```ts
 * isNonEmptyArray([1, 2, 3]); // => true
 * isNonEmptyArray(['a']); // => true
 * isNonEmptyArray([]); // => false
 * isNonEmptyArray(null); // => false
 * isNonEmptyArray(undefined); // => false
 * isNonEmptyArray({}); // => false
 * ```
 */
export function isNonEmptyArray<T>(value: unknown): value is T[] {
  return Array.isArray(value) && value.length > 0;
}
